import { Button, ButtonThemesEnum } from '@propertyfinder/button';
import { DrawerAnimationDirectionEnum, DrawerComponent } from '@propertyfinder/drawer';
import { TextField } from '@propertyfinder/text-field';
import { FunctionalComponent, h } from 'preact';
import { useState } from 'preact/hooks';

import { SaveSearchModel } from 'common/data/save-search/model';
import { i18nTranslate } from 'common/helper/i18n/translate';
import { MessageViewStore } from 'common/module/message/view-store';
import { SaveSearchStoreService } from 'common/service/save-search-store/service';

export const SaveSearchListRenameDrawerComponent: FunctionalComponent<{
  saveSearchModel: SaveSearchModel;
  closeModal: () => void;
  messageService: MessageViewStore;
}> = ({ saveSearchModel, closeModal, messageService }) => {
  const [alertName, setAlertName] = useState(saveSearchModel.name);
  const [isDisabled, setIsDisabled] = useState(false);

  return (
    <DrawerComponent
      onClose={closeModal}
      openOnLoad={true}
      className={'rename__drawer'}
      headerClassName={'rename__drawer--header'}
      contentClassName={'rename__drawer--content'}
      footerClassName={'rename__drawer--footer'}
      showCloseButton={false}
      openingDirection={DrawerAnimationDirectionEnum.UP}
      header={<div>{i18nTranslate('Rename')}</div>}
      footer={
        <Button
          theme={ButtonThemesEnum.PRIMARY}
          type={'submit'}
          disabled={isDisabled}
          onClick={(): void => {
            setIsDisabled(true);
            SaveSearchStoreService()
              .update(saveSearchModel.id, {
                name: alertName,
                frequency: saveSearchModel.frequency,
              })
              .then((response) => {
                setIsDisabled(false);
                closeModal();
                messageService.alert({
                  message: i18nTranslate('ManageAlert_RenameMessage'),
                });
                return response;
              })
              .catch((): void => {
                setAlertName(i18nTranslate('Something went wrong! Please try again later'));
              });
          }}
        >
          {i18nTranslate('Save')}
        </Button>
      }
    >
      {i18nTranslate('ManageAlert_AlertName')}
      <TextField
        value={alertName}
        onInput={(e: InputEvent): void => setAlertName((e.target as HTMLInputElement).value)}
      />
    </DrawerComponent>
  );
};
